import { render, staticRenderFns } from "./DadosOcorrencia.vue?vue&type=template&id=18ad335e&scoped=true"
import script from "./DadosOcorrencia.vue?vue&type=script&lang=js"
export * from "./DadosOcorrencia.vue?vue&type=script&lang=js"
import style0 from "./DadosOcorrencia.vue?vue&type=style&index=0&id=18ad335e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ad335e",
  null
  
)

export default component.exports